import { Box } from "@planningcenter/tapestry-react"

const RemindersForm = () => {
  return <Box>Placeholder: EditingForm</Box>
}

export default RemindersForm
